import { Component } from '@angular/core';
import { global } from "../../../services/global";
import { Location } from "@angular/common";
import { UploadService } from "../../../services/upload.service";
import { ActivatedRoute } from "@angular/router";
import { ConnectionService } from "../../../services/connection.service";
import { AuthService } from "../../../services/auth.service";

@Component({
    selector: 'app-albaran-images',
    templateUrl: './albaran-images.component.html',
    styleUrls: ['./albaran-images.component.scss'],
    standalone: false
})
export class AlbaranImagesComponent {

    name = "";

    url = global.getUrl();

    showLoader: boolean = false;

    documents: any;
    idAlbara: any;

    // Motivo por el que no hay imágenes que enseñar (sesión caducada, albarán ajeno, sin cobertura)
    messageError: string = "";

    constructor(
        private location: Location,
        private uploadService: UploadService,
        private route: ActivatedRoute,
        private connection: ConnectionService,
        private auth: AuthService
    ) {
    }

    /**
     * URL de descarga de un documento. El token va en la URL porque <img> y <a> no pueden mandar
     * la cabecera Authorization, y el backend ya no sirve documentos sin identificar.
     */
    downloadUrl(documentId: string | number): string {
        const token = encodeURIComponent(this.auth.getToken() ?? '');

        return this.url + 'xofers/download?id=' + documentId + '&token=' + token;
    }

    // 401: la sesión ha caducado. 404: el albarán ya no es de este xofer (o no existe).
    downloadErrorMessage(error: any): string {
        if (this.connection.reportError(error)) {
            return "Sin conexión: no se pueden cargar las imágenes hasta recuperar cobertura.";
        }

        if (error?.status === 401) {
            return "Tu sesión ha caducado. Vuelve a identificarte para ver las imágenes.";
        }

        if (error?.status === 404) {
            return "Este albarán ya no está asignado a ti, así que no se pueden ver sus imágenes.";
        }

        return error?.error?.message ?? "No se han podido cargar las imágenes.";
    }

    ngOnInit(): void {
        this.route.params.subscribe(
            (params) => {
                this.idAlbara = params['idAlbara'];
                this.name = "Ver imágenes salidas y llegadas - " + params['idAlbara'];
            }
        );

        this.showLoader = true;

        this.uploadService.getImages(this.idAlbara).subscribe(
            {
                next: img => {
                    this.documents = img.documents;
                    this.messageError = "";
                    this.connection.reportSuccess();
                    this.showLoader = false;
                }, error: error => {
                    // Sin esto el loader se quedaba girando para siempre
                    this.documents = [];
                    this.messageError = this.downloadErrorMessage(error);
                    this.showLoader = false;
                }
            }
        )
    }

}
